import React from 'react';
import classnames from 'classnames';
export const ActionToolbar = ({ content, sticky, className, }) => {
    const actionToolbarSticky = sticky !== null && sticky !== void 0 ? sticky : false;
    const ActionToolbarClasses = classnames('Page__actionToolbar', className, {
        'Page__actionToolbar--sticky': actionToolbarSticky,
    });
    return React.createElement("div", { className: ActionToolbarClasses }, content);
};
//# sourceMappingURL=ActionToolbar.js.map